import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BlockNote } from 'src/config/api/models/BlockNote';


type CurrentEditingNote = {
  isEditing?: boolean;
  hasChangedContent?: string;
  selectedNoteId?: string;
  selectedNoteBlockId?: string;
  resetEditingBlockNoteId?: boolean;
}
export interface BlockNotesState {
  blockNotes?: BlockNote[];
  studentMode?: boolean;
  currentStudent?: Record<string, any>;
  currentGroup?: Record<string, any>;
  currentEditingNote: CurrentEditingNote;
}

export const initialState: BlockNotesState = {
  blockNotes: undefined,
  studentMode: false,
  currentStudent: undefined,
  currentGroup: undefined,
  currentEditingNote: {
    isEditing: false,
    hasChangedContent: '',
    selectedNoteId: '',
    selectedNoteBlockId: '',
    resetEditingBlockNoteId: false,
  },
};

export const blockNotesSlice = createSlice({
  name: 'blockNotesSlice',
  initialState,
  reducers: {
    setBlockNotes: (state, action: PayloadAction<BlockNote[]>) => {
      state.blockNotes = action.payload;
    },
    setStudentMode: (state, action: PayloadAction<boolean>) => {
      state.studentMode = action.payload;
    },
    setCurrentStudent: (state, action: PayloadAction<Record<string, any> | undefined>) => {
      if (state.currentStudent !== action.payload) {
        state.currentStudent = action.payload;
      }
    },
    setCurrentGroup: (state, action: PayloadAction<Record<string, any> | undefined>) => {
      state.currentGroup = action.payload;
    },
    setCurrentEditingNote: (state, action: PayloadAction<CurrentEditingNote>) => {
      state.currentEditingNote = { ...state.currentEditingNote, ...action.payload } ;
    },
    resetCurrentEditingNote: (state) => {
      state.currentEditingNote = { ...initialState.currentEditingNote } ;
    },
  },
});

export const { setBlockNotes, setStudentMode, setCurrentStudent, setCurrentGroup, setCurrentEditingNote, resetCurrentEditingNote } =
  blockNotesSlice.actions;

export const { reducer: blockNotesReducer } = blockNotesSlice;
